import { Box, Button } from '@mui/material';
import React from 'react';
import { forwardRef, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
const AddEditRoleForm = forwardRef(({ onSubmit, onCancel, dialog = false, edit, role }, ref) => {
    const { t } = useTranslation();
    const prevRoleId = useRef();
    const { control, handleSubmit, reset, formState: { errors } } = useForm({
        shouldFocusError: false
    });
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            borderRadius: (theme) => theme.spacing(4),
            gap: 1.5,
            height: 'auto', p: dialog ? 2 : 0
        } }, !dialog && (React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: (theme) => theme.spacing(1),
            mb: (theme) => theme.spacing(1)
        } },
        React.createElement(Button, { fullWidth: true, onClick: onCancel, variant: 'outlined', color: 'inherit', size: 'large' }, t('common:actions.cancel')),
        React.createElement(Button, { fullWidth: true, variant: 'contained', color: 'inherit', onClick: onCancel, size: 'large' }, edit ? t('common:actions.editNow') : t('common:actions.addNow'))))));
});
export default AddEditRoleForm;
